/**
 * --------------------------------------------------------------------------
 * Color Theme color-theme.js
 * 1.0.0
 * --------------------------------------------------------------------------
 */

const colorTheme = () => {
    //console.log("color-theme.js loaded");

    // Il sito ospitante che integra la dashboard in iframe non gestisce la dark mode:
    // forziamo la modalità light e ignoriamo preferenza di sistema/localStorage.
    if (document.body.classList.contains("is-iframe")) {
        document.documentElement.setAttribute("data-bs-theme", "light");
        return;
    }

    const storedTheme = localStorage.getItem("theme");

    const getPreferredTheme = () => {
        return storedTheme || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    };

    const setTheme = (theme) => {
        if (theme === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches) {
            document.documentElement.setAttribute("data-bs-theme", "dark");
        } else {
            document.documentElement.setAttribute("data-bs-theme", theme);
        }
    };

    setTheme(getPreferredTheme());

    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
        if (storedTheme !== "light" && storedTheme !== "dark") {
            setTheme(getPreferredTheme());
        }
    });

    window.addEventListener("DOMContentLoaded", () => {
        document.querySelector("#theme-toggle")?.addEventListener("click", () => {
            const currentTheme = localStorage.getItem("theme");
            const switchTheme = currentTheme === "light" ? "dark" : "light";
            setTheme(switchTheme);
            localStorage.setItem("theme", switchTheme);
        });
    });
};
export default colorTheme;
